
export const getGeorgianTime = () => {
    return new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Tbilisi" }));
};

export const isRestaurantOpen = () => {
    return true;
};

export const getOpeningHoursMessage = () => {
    return "14:00 - 02:00";
};
